/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ANNUAL_PASS_ID } from '../src/constants';

const childRoutes = [];

// Interagency Annual Pass Page
childRoutes[childRoutes.length] = {
    path: '/pass/interagency-annual-pass',
    componentName: 'InteragencyAnnualPass',
    title: 'Interagency Annual Pass',
};

// order-details for interagency annual pass
childRoutes[childRoutes.length] = {
    path: `/pass/order-details/pass/${ANNUAL_PASS_ID}`,
    componentName: 'PassTypePageWrapper',
    title: 'Order Details',
};

// order-details/reservation is for UPDATING a reservation
childRoutes[childRoutes.length] = {
    path: '/pass/order-details/reservation/:resId',
    componentName: 'ReservationPageWrapper',
    title: 'Order Details',
};

// which pass wizard for mobile apps
childRoutes[childRoutes.length] = {
    path: '/pass/mobile/whichpass',
    componentName: 'MobileWhichPassContainer',
    title: 'Which Pass do I Need?',
};

// Buy a Pass
childRoutes[childRoutes.length] = {
    path: '/pass',
    componentName: 'PassLandingPage',
    title: 'Buy a Pass',
};

export default childRoutes;
